import React from "react";
import Notices from "../Notices";

const MyNotices = (props) => {
  return <Notices {...props} />;
};

const module = {
  routeProps: {
    path: "NewsItems",
    component: MyNotices,
  },
  name: "newsItem",
  label: "News Items",
  title: "Travel Midwest News Items",
  showOnMenu: true,
};

export default module;
